import React from "react";
import { LoadingImgIcon } from "../../assets/icons";
import { DoughWithNoData } from "../../utils/DoughNutChart";

function MainDashboardLoader() {
  return (
    <div className=" h-44 w-[100%] border flex flex-col items-center justify-center border-borderdark rounded-xl py-3 px-4 m-auto animate-pulse gap-y-3">
      <div className=" w-full flex justify-between items-center">
      <div className=" flex items-center justify-center w-28 h-28 bg-gray-100 rounded">
        <LoadingImgIcon />
      </div>
      <div className=" flex items-center bg-gray-100 rounded-full justify-center w-24 h-24">
        <div className=" w-12 h-12 bg-white rounded-full"></div>
      </div>
      </div>
      <div className=" w-full flex justify-between items-center">
        {[...Array(3)].map((_, index) => {
          return (
            <div
              className=" flex flex-col justify-center items-center "
              key={index}
            >
              <div class="h-3 bg-gray-100 rounded-full w-20  my-2"></div>
              <div class="h-2.5 bg-gray-100 rounded-full w-16"></div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default MainDashboardLoader;
